import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import subgroup from "./subgroup";
import common from '@/config';
import { getObj } from '@/api/bigscreen/visual';
export default {
  name: 'contents',
  inject: ["contain"],
  props: {
    props: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    wscale: Number
  },
  provide: function provide() {
    return {
      contain: this.contain,
      container: this
    };
  },
  components: {
    subgroup: subgroup
  },
  data: function data() {
    return {
      selectCount: {},
      scale: 1,
      scaleH: 1,
      gradeFlag: false,
      pageName: ''
    };
  },
  computed: {
    stepScale: function stepScale() {
      var scale = Number(100 / (this.scale * this.wscale)).toFixed(2);
      return scale;
    },
    //计算中央可视化大屏比例
    styleName: function styleName() {
      var _this = this;

      var scale = this.contain.config.scale;
      var transName = null;

      if (this.pageName == 'view') {
        transName = "scale(".concat(scale / 100, ", ").concat(this.scaleH / 100, ")");
      } else {
        transName = "scale(".concat(scale / 100, ", ").concat(this.scale / 100, ")");
      }

      return Object.assign({
        transform: transName,
        width: this.setPx(this.contain.config.width),
        height: this.setPx(this.contain.config.height),
        backgroundColor: this.contain.config.backgroundColor
      }, function () {
        if (_this.contain.config.backgroundImage) {
          return {
            background: "url(".concat(_this.contain.config.backgroundImage, ") 0% 0% / 100% 100% rgb(3, 12, 59)")
          };
        }

        return;
      }());
    },
    gradeLenStyle: function gradeLenStyle() {
      return {
        backgroundSize: "".concat(this.setPx(this.contain.config.gradeLen), " ").concat(this.setPx(this.contain.config.gradeLen), ",").concat(this.setPx(this.contain.config.gradeLen), " ").concat(this.setPx(this.contain.config.gradeLen))
      };
    }
  },
  mounted: function mounted() {
    this.initData();
    this.initFun();
  },
  methods: {
    initFun: function initFun() {
      var _this2 = this;

      ['handleRefresh', 'handleGetObj'].forEach(function (ele) {
        _this2[ele] = _this2.$refs.subgroup[ele];
      });
    },
    //初始化数据
    initData: function initData() {
      var _this3 = this;

      var id = this.$route ? this.$route.params.id : this.props.id;
      console.log(this.$route);
      this.pageName = this.$route.name;
      this.contain.id = id;
      this.contain.contentWidth = this.$refs.content.offsetWidth;
      var isBuild = this.$route ? this.$route.name === 'build' : this.props.name;
      var width = isBuild ? this.contain.contentWidth : document.body.clientWidth;
      var height = isBuild ? this.contain.contentHeight : document.body.clientHeight;

      if (id) {
        var loading = this.$loading({
          lock: true,
          text: '正在加载中，请稍后',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        getObj(id).then(function (res) {
          var callback = function callback() {
            //赋值属性
            _this3.contain.config = JSON.parse(config.detail) || {};
            _this3.contain.nav = JSON.parse(config.component) || [];

            if (_this3.contain.config.mark.show && !isBuild) {
              _this3.watermark(_this3.contain.config.mark);
            }

            _this3.calcData();

            _this3.setScale(width, height);
          };

          var data = res.data.data;
          _this3.contain.obj = data;
          var config = data.config;
          _this3.contain.visual = data.visual; //添加水印。只有查看页面生效

          if (!isBuild) {
            var password = _this3.contain.visual.password;

            if (!_this3.validatenull(password)) {
              _this3.$prompt('请输入密码', '提示', {
                confirmButtonText: '确定',
                showCancelButton: false,
                showClose: false,
                closeOnClickModal: false,
                inputPattern: new RegExp(password),
                inputErrorMessage: '密码不正确，请重新输入'
              }).then(function () {
                callback();
              });
            } else {
              callback();
            }
          } else {
            callback();
          }

          loading.close();
        }).catch(function (err) {
          console.log(err);
          loading.close();
        });
      } else {
        this.setScale(width, height);
      }
    },
    //适配尺寸
    setResize: function setResize() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.$refs.content.style.width = _this4.setPx(_this4.contain.config.scale * _this4.contain.config.width / 100);

        if (_this4.pageName == 'view') {
          _this4.$refs.content.style.height = _this4.setPx(_this4.contain.config.scaleH * _this4.contain.config.height / 100);
        } else {
          _this4.$refs.content.style.height = _this4.setPx(_this4.contain.config.scale * _this4.contain.config.height / 100);
        } //this.$refs.content.style.overflowY =  'auto' 

      });
    },
    //计算比例
    setScale: function setScale(width, height) {
      var _this5 = this;

      this.$nextTick(function () {
        _this5.contain.config.scale = width / _this5.contain.config.width * 100;
        _this5.contain.config.scaleH = height / _this5.contain.config.height * 100;
        _this5.scale = _this5.contain.config.scale;
        _this5.scaleH = _this5.contain.config.scaleH;

        _this5.setResize();
      });
    },
    calcData: function calcData() {
      if (!this.contain.config.mark) this.contain.config.mark = {};
      if (!this.contain.config.query) this.contain.config.query = {};
    },
    handlePostionSelect: function handlePostionSelect(postion) {
      this.handleCalcPostionSelect();
      var x1 = this.selectCount.maxx1;
      var x2 = this.selectCount.maxx2;
      var y1 = this.selectCount.maxy1;
      var y2 = this.selectCount.maxy2;

      if (postion === 'left') {
        this.handleMoveSelectList(x1, undefined, true, postion);
      } else if (postion === 'center') {
        this.handleMoveSelectList(x1 + (x2 - x1) / 2, undefined, true, postion);
      } else if (postion === 'right') {
        this.handleMoveSelectList(x2, undefined, true, postion);
      } else if (postion === 'top') {
        this.handleMoveSelectList(undefined, y1, true, postion);
      } else if (postion === 'middle') {
        this.handleMoveSelectList(undefined, y1 + (y2 - y1) / 2, true, postion);
      } else if (postion === 'bottom') {
        this.handleMoveSelectList(undefined, y2, true, postion);
      }
    },
    handleMoveSelectList: function handleMoveSelectList(left, top, type, postion) {
      var _this6 = this;

      this.contain.active.forEach(function (ele) {
        ele = _this6.contain.findlist(ele);
        var ele_component = ele.component; //水平情况

        if (left) {
          var baseLeft = Number(type ? left : (ele.left + left).toFixed(2));

          if (postion === 'right') {
            baseLeft = baseLeft - ele_component.width;
          } else if (postion === 'center') {
            var obj_center = ele.left + ele_component.width / 2;
            baseLeft = ele.left + (left - obj_center);
          }

          _this6.$set(ele, 'left', baseLeft);

          _this6.$refs.subgroup.$refs[common.DEAFNAME + ele.index][0].setLeft(baseLeft);
        } //垂直情况


        if (top) {
          var baseTop = Number(type ? top : (ele.top + top).toFixed(2));

          if (postion === 'bottom') {
            baseTop = baseTop - ele_component.height;
          } else if (postion === 'middle') {
            var obj_middle = ele.top + ele_component.height / 2;
            baseTop = ele.top + (top - obj_middle);
          }

          _this6.$set(ele, 'top', baseTop);

          _this6.$refs.subgroup.$ref[common.DEAFNAME + ele.index][0].setTop(baseTop);
        }
      });
    },
    //计算多选状态下的最大边界值
    handleCalcPostionSelect: function handleCalcPostionSelect() {
      var _this7 = this;

      this.selectCount.maxx1 = 99999;
      this.selectCount.maxy1 = 99999;
      this.contain.active.forEach(function (ele) {
        ele = _this7.contain.findlist(ele);
        var left = ele.left;
        var top = ele.top;
        var width = ele.component.width;
        var height = ele.component.height;

        if (_this7.selectCount.maxx1 > left) {
          _this7.selectCount.maxx1 = left;
        }

        if (_this7.selectCount.maxx2 < left + width) {
          _this7.selectCount.maxx2 = left + width;
        }

        if (_this7.selectCount.maxy1 > top) {
          _this7.selectCount.maxy1 = top;
        }

        if (_this7.selectCount.maxy2 < top + height) {
          _this7.selectCount.maxy2 = top + height;
        }
      });
    }
  }
};